import React from 'react';
import { Select } from 'swag-client-common/components/pickers/select-field';
import { COUNTRIES } from 'swag-common/utils/shipping';
export const CountryPicker = ({
  value,
  onChange,
  disabled = false,
  fullWidth = false,
  autoWidth = true,
  style,
  dataDropdown = 'Country',
  wrapperClassName = '',
  className,
  hintText = 'Country',
  valueOutsideList = undefined
}) => {
  const options = COUNTRIES.map(item => ({
    value: item.code,
    label: item.label,
    key: item.code,
    isHidden: false
  }));
  if (valueOutsideList) {
    options.push({
      value: String(valueOutsideList),
      label: String(valueOutsideList),
      key: String(valueOutsideList),
      isHidden: true
    });
  }
  return /*#__PURE__*/React.createElement(Select, {
    dataDropdown: dataDropdown,
    disabled: disabled,
    value: value,
    onChange: onChange,
    fullWidth: fullWidth,
    autoWidth: autoWidth,
    style: style,
    hintText: hintText,
    className: className,
    wrapperClassName: wrapperClassName,
    options: options
  });
};